import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { MarkerTypeWaterActivity } from 'types/markerTypes/location-markers-type.js';
import { MarineMarkerLocationTypeCustom } from 'types/markerTypes/markers.waterActivityMarine.js';
import { ILocationSummaryV1 } from 'types/markerTypesV1/marker-v1-view-type.js';
import { getDefaultWaterMarkerIconName } from '../default-marker-behaviour/utils.js';
import { getMarineWeatherRisk } from './utils.js';

export const MarineMarkerFavForecast = ({
  value,
  className,
  marker,
}: {
  className?: string;
  value: ILocationSummaryV1<MarineMarkerLocationTypeCustom>['value'];
  marker: typeof MarkerTypeWaterActivity.Paddleboarding | typeof MarkerTypeWaterActivity.Kayak;
}) => {
  const { risk } = value ?? {};
  const weatherRisk = getMarineWeatherRisk(marker, value);
  const { status, text } = weatherRisk ?? {};

  const icon = getDefaultWaterMarkerIconName(marker, weatherRisk?.status);

  return (
    <>
      <IconWithText
        sizePadding={[32, 24]}
        size={24}
        icon={icon}
        classes={classNames(className, 'u-flex-1 IconWithText--vCenter u-mT-0')}
      >
        <div className="u-mT-0 u-mB-0  u-mL-xs u-flex u-flexJustifyBetween">
          <div className={classNames('u-flex-1 u-mT-0 u-mB-0 u-text-sm')}>{text}</div>
          <div className={classNames('u-flexGrow-0 u-text-sm u-textSemibold', status)}>{risk?.text}</div>
        </div>
      </IconWithText>
    </>
  );
};

/** Displays in searchbar */
export const marineMarkerFavSearchbar = (
  type: MarineMarkerLocationTypeCustom['type'],
  value: MarineMarkerLocationTypeCustom['value'],
): IconNameV1 => {
  const weatherRisk = getMarineWeatherRisk(type, value);
  const { status } = weatherRisk ?? {};
  return getDefaultWaterMarkerIconName(type, status);
};
